<div class="home-wrapper">
  @if (!loaded) {
    <app-skeleton-loader Cwidth="1536" Cheight="660"></app-skeleton-loader>
  }
  @if (loaded) {
    <div>
      @for (header of homeHeroResponse?.merchandising?.content?.header; track header) {
        <div>
          <div [innerHTML]="header"></div>
        </div>
      }
    </div>
  }

  <!--/home-hero-->

  <div class="top-categories mobile-min-height-650px">
    @if (loaded) {
      <div class="mx-auto container container-padding py-12 text-center">
        <div class="text-center uppercase text-30px font-display lines-centered-red mb-4">
          Top Categories
        </div>
        <div class="flex flex-wrap top-categories__list" style="justify-content: center;">
          @if (loaded) {
            @for (categories of featuredCategories?.content; track categories; let i = $index) {
              <a
                [routerLink]="['/product/', getUrl(categories.categoryFilter.toLowerCase())]"
                class="block text-center top-categories__list__item">
                <div class="top-categories__list__item__image">
                  <img class="rounded-lg" width="248" height="163" fetchpriority="high" loading="lazy" [src]="categories?.images[3]?.url" [alt]="categories?.name + '-' + i">
                </div>
                <strong class="inline-block mt-2 text-black">
                  <span>{{categories?.name}}</span>
                </strong>
              </a>
            }
          }
          @if (!loaded) {
            @for (skel of ['', '', '', '']; track skel) {
              <a class="block text-center top-categories__list__item">
                <app-skeleton-loader Cwidth="248" Cheight="162.933"></app-skeleton-loader>
                <strong class="inline-block mt-2 text-black">
                  <app-skeleton-loader Cwidth="148.133" Cheight="24"></app-skeleton-loader>
                </strong>
              </a>
            }
          }
        </div>
      </div>
    }
  </div>

  <!--/top-categories-->

  @if (homeHeroResponse?.results?.length > 0) {
    <div class="top-products slider-dark text-white mobile-min-height-720px bg-none" appBackgroundLazyLoad>
      <div class="mx-auto container md-container-padding py-12">
        <div class="text-center uppercase text-30px font-display lines-centered-white mb-8">
          Top Products
        </div>
        <div class="product-video" role="region" aria-label="Carousel" aria-live="polite">
          <ngx-slick-carousel class="carousel" #frequentlyPurchasedSlickModal="slick-carousel" [config]="frequentlyPurchasedSlideConfig">
            @for (product of homeHeroResponse?.results; track product; let i = $index) {
              <div ngxSlickItem class="product-list__item no-underline" #productElem
                tabindex="-1">
                <div class="top-categories__list__item__image">
                  <a [routerLink]="['/product/product-detail/' + product.g_item_group_id]"
                    (mousedown)="intellisuggestProductTrackClick(productElem, product.intellisuggestData, product.intellisuggestSignature)">
                    @if (!loaded) {
                      <app-skeleton-loader Cwidth="182" Cheight="182"></app-skeleton-loader>
                    }
                    @if (loaded) {
                      <img width="182" height="182" style="border-radius: 8px;" [src]="product?.thumbnailImageUrl" [alt]="product?.name" appImageLazyLoad loading="lazy">
                    }
                  </a>
                </div>
                <div class="mt-3 font-display text-blue-dark opacity-50 uppercase text-22px product-list__item__brand">
                  @if (!loaded) {
                    <app-skeleton-loader Cwidth="79.08" Cheight="24.8"></app-skeleton-loader>
                  }
                  @if (loaded) {
                    <span>{{product?.brand}}</span>
                  }
                </div>
                @if (!loaded) {
                  <app-skeleton-loader Cwidth="204.4" Cheight="50"></app-skeleton-loader>
                }
                @if (loaded) {
                  <a class="text-lg text-black font-bold no-underline" [routerLink]="['/product/product-detail/' + product.g_item_group_id]"
                    (mousedown)="intellisuggestProductTrackClick(productElem, product.intellisuggestData, product.intellisuggestSignature)">
                    <span>{{product?.name}}</span>
                  </a>
                }
                <div class="mb-3 text-black">
                  @if (!loaded) {
                    <app-skeleton-loader Cwidth="135" Cheight="20"></app-skeleton-loader>
                  }
                  @if (loaded) {
                    <i>Starting at ${{product?.ss_price_min}}</i>
                  }
                </div>
                @if (!loaded) {
                  <app-skeleton-loader Cwidth="125.4" Cheight="17"></app-skeleton-loader>
                }
                @if (loaded) {
                  <app-bazaarvoice-rating [productId]="product?.g_item_group_id"></app-bazaarvoice-rating>
                }
              </div>
            }
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  }

  <!--/top-products-->

  <div class="callout-section mt-20">
    <div class="mx-auto container container-padding py-8 md:flex md:flex-row-reverse lg:py-16">
      <div class="md:w-1/2">
        <div class="mb-4">
          @if (!loaded) {
            <app-skeleton-loader Cwidth="600" Cheight="430"></app-skeleton-loader>
          }
          @if (loaded) {
            <img fetchpriority="high" width="600" height="430" class="home-callout-section__image" [src]="'../assets/img/home/totalboat.webp'" alt="home-totalboat" appImageLazyLoad loading="lazy">
          }
          <img fetchpriority="high" class="callout-section__image__overlay" width="224" height="84" [src]="'../assets/img/totalboat-white.svg'" alt="totalboat-white" appImageLazyLoad loading="lazy">
        </div>
      </div>
      <div class="md:w-1/2 md:pr-4 lg:pr-8 md:flex items-center">
        <div>
          <div class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0">
            @if (!loaded) {
              <app-skeleton-loader Cwidth="101.84" Cheight="34.4"></app-skeleton-loader>
            }
            @if (loaded) {
              <span>Totalboat</span>
            }
          </div>
          @if (!loaded) {
            <app-skeleton-loader Cwidth="568" Cheight="72"></app-skeleton-loader>
          }
          @if (loaded) {
            <p>Explore the most comprehensive lineup of marine maintenance & repair solutions available. DIY makers & woodworkers prefer TotalBoat products for their ease of use and marine-grade durability.</p>
          }
          @if (!loaded) {
            <app-skeleton-loader Cwidth="106.65" Cheight="35"></app-skeleton-loader>
          }
          @if (loaded) {
            <a [routerLink]="['/product/brand/totalboat-page']" class="inline-block mt-1 button button--small button--border w-full md:w-auto" style="min-height: 48px; display: inline-flex; align-items: center; justify-content: center;">SHOP NOW</a>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="logo-bar popular-brands-logos">
    <div class="mx-auto container container-padding py-6 md:py-12 lg:pt-16 lg:pb-6">
      @if (!loaded) {
        <app-skeleton-loader Cwidth="1000" Cheight="112"></app-skeleton-loader>
      }
      @if (loaded) {
        <div class="text-black text-30px text-center uppercase font-display mb-8">
          @for (banner of homeHeroResponse?.merchandising?.content?.banner; track banner) {
            <div>
              <div [innerHTML]="banner"></div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="callout-section">
    <div class="mx-auto container container-padding px-4 pt-0 md:pt-6 md:flex pb-10 md:pb-20">
      <div class="md:w-1/2">
        <div class="mb-4">
          @if (!loaded) {
            <app-skeleton-loader Cwidth="600" Cheight="430.2"></app-skeleton-loader>
          }
          @if (loaded) {
            <img [src]="'../assets/img/home/about.webp'" width="200" height="170" appImageLazyLoad loading="lazy" class="home-callout-section__image" alt="home-about">
          }
        </div>
      </div>
      <div class="md:w-1/2 md:pl-4 lg:pl-8 md:flex items-center">
        <div>
          <div class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0">
            @if (!loaded) {
              <app-skeleton-loader Cwidth="98.16" Cheight="34.4"></app-skeleton-loader>
            }
            @if (loaded) {
              <span>About Us</span>
            }
          </div>
          @if (!loaded) {
            <app-skeleton-loader Cwidth="568" Cheight="72"></app-skeleton-loader>
          }
          @if (loaded) {
            <p>Our mission is to provide Tools and Inspiration for Craftsmen. We've been supplying building & maintenance products to boaters, builders & DIY makers since 1977. We love to help people build stuff!</p>
          }
          @if (loaded) {
            <a href="javascript:void(0)" (click)="navigateToAboutUs()" class="inline-block mt-1 button button--small button--border w-full md:w-auto" style="min-height: 48px; display: inline-flex; align-items: center; justify-content: center;">
              @if (!loaded) {
                <app-skeleton-loader Cwidth="76" Cheight="20"></app-skeleton-loader>
              }
              <span>Learn More</span>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
  <!--/callout-section-->

</div>
<!--/home-wrapper-->

<support-footer></support-footer>

<!-- Free Shipping Modal -->
<ng-template #freeShippingComponent>
  <a class="js-close-modal text-grey text-4xl modal__close" (click)="active = !active"><i class="fal fa-times"></i></a>
  <app-free-shipping [modalView]="true" (closeModal)="toggleModal();"></app-free-shipping>
</ng-template>
<app-modal [template]="freeShippingComponent" [active]="false"></app-modal>